this.changeBgImage = (images) ->

  i = Math.floor(Math.random() * 30);
  $('body').css('background-image', 'url(' + images[i] + ')');

  setTimeout (->
    changeBgImage(images)
  ), 4000
